// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownHeading_wrapper_3eifp","heading":"DropdownHeading_heading_2pBB7","lead":"DropdownHeading_lead_1ycaE"};